/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { NavigationItem } from '@squiz/sds';
import {
  DASHBOARD,
  EVENTS,
  EVENT_BUILDER_CREATE_DATA_INTEGRATION,
  EVENT_BUILDER_CREATE_WEB_BEHAVIOR,
  EVENT_BUILDER_UPDATE,
  SCV_CUSTOMERS,
  SCV_CUSTOMER_PROFILE,
  SCV_EXPORTS,
  SCV_SEGMENT_INSIGHTS,
  SEGMENTATION,
  SEGMENT_BUILDER_CREATE,
  SEGMENT_BUILDER_UPDATE,
} from './Screens.constants';

/**
 * All navigation items that make up general Customer Data Platform screens.
 */
export const DXP_MENU_CDP_SCREENS: Array<NavigationItem> = [
  DASHBOARD,
  SEGMENTATION,
  SEGMENT_BUILDER_CREATE,
  SEGMENT_BUILDER_UPDATE,
  EVENTS,
  EVENT_BUILDER_CREATE_DATA_INTEGRATION,
  EVENT_BUILDER_CREATE_WEB_BEHAVIOR,
  EVENT_BUILDER_UPDATE,
];

/**
 * All navigation items that make up Single Customer View screens.
 */
export const DXP_MENU_SCV_SCREENS: Array<NavigationItem> = [
  SCV_CUSTOMER_PROFILE,
  SCV_SEGMENT_INSIGHTS,
  SCV_CUSTOMERS,
  SCV_EXPORTS,
];
